/**
 * Tables Routes
 */
import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Redirect, Route, RouteChildrenProps, Switch} from 'react-router-dom';
// async components
import {AsyncTagsListComponent} from '../components/AsyncComponent/AsyncComponent';
import {useTranslation} from "react-i18next";
import {config} from "../config";

const Tags: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();
    return (
        <div className="content-wrapper">
            <Helmet>
                <title>{`${config.app.name} - ${translate('tags.name')}`}</title>
                <meta name="description" content="Tags"/>
            </Helmet>
            <Switch>
                <Route exact path={`${match?.url}`} component={AsyncTagsListComponent}/>
                <Redirect exact from={`${match?.url}/`} to={`${match?.url}`}/>
            </Switch>
        </div>
    );
};

export default Tags;
